var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataNitiv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_dn_sync)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 14.4004C19 15.6611 18.7542 16.9094 18.2769 18.0741C17.7994 19.2389 17.0997 20.2972 16.2175 21.1886C15.3354 22.0801 14.2881 22.7871 13.1355 23.2696C11.9829 23.752 10.7475 24.0004 9.5 24.0004C8.25244 24.0004 7.0171 23.752 5.86451 23.2696C4.71191 22.7871 3.66464 22.0801 2.78248 21.1886C1.90033 20.2972 1.20056 19.2389 0.723144 18.0741C0.245724 16.9094 -1.09065e-07 15.6611 0 14.4004H4.75C4.75 15.0307 4.87286 15.6549 5.11157 16.2373C5.35029 16.8196 5.70016 17.3487 6.14125 17.7945C6.58232 18.2402 7.10595 18.5938 7.68225 18.835C8.25855 19.0763 8.87622 19.2004 9.5 19.2004C10.1238 19.2004 10.7415 19.0763 11.3177 18.835C11.894 18.5938 12.4176 18.2402 12.8587 17.7945C13.2998 17.3487 13.6497 16.8196 13.8884 16.2373C14.1272 15.6549 14.25 15.0307 14.25 14.4004H19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9 9.59961H0V13.4396H1.9V9.59961Z",
    fill: "#FABB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75156 7.67969H2.85156V13.4397H4.75156V7.67969Z",
    fill: "#FABB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0016 0H17.1016V13.44H19.0016V0Z",
    fill: "#FABB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.15 1.91992H14.25V13.4399H16.15V1.91992Z",
    fill: "#FABB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59922 9.99913C6.84266 10.3332 6.18909 10.8608 5.69922 11.5198V5.75977H7.59922V9.99913Z",
    fill: "#FABB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4508 9.69638C10.1438 9.61805 9.82616 9.57637 9.50078 9.57637C9.1754 9.57637 8.85776 9.61805 8.55078 9.69638V4.7998H10.4508V9.69638Z",
    fill: "#FABB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2984 11.5198C12.8086 10.8608 12.155 10.3332 11.3984 9.99913V5.75977H13.2984V11.5198Z",
    fill: "#FABB00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_dn_sync"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataNitiv);
export default __webpack_public_path__ + "static/media/DataNitiv.6b4099d2fc39f76485eb9da06f17d027.svg";
export { ForwardRef as ReactComponent };